import { render, staticRenderFns } from "./OnboardingStories.vue?vue&type=template&id=1d605bd8&scoped=true"
import script from "./OnboardingStories.vue?vue&type=script&lang=js"
export * from "./OnboardingStories.vue?vue&type=script&lang=js"
import style0 from "./OnboardingStories.vue?vue&type=style&index=0&id=1d605bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d605bd8",
  null
  
)

export default component.exports